"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalVideoPlaylistNugget = _interopRequireDefault(require("./DrupalVideoPlaylistNugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _Constants = require("../../../constants/Constants");

var _VideoPlaylistNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/VideoPlaylistNugget"));

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _PauseCircleFilled = _interopRequireDefault(require("@material-ui/icons/PauseCircleFilled"));

var _VideoActionManager = _interopRequireDefault(require("./VideoActionManager"));

var _WatchedSequences = _interopRequireDefault(require("./WatchedSequences"));

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _ListenedSequences = _interopRequireDefault(require("./ListenedSequences"));

var _Video = _interopRequireDefault(require("../../Video/Video"));

var _UrlHelper = _interopRequireDefault(require("../../../../helpers/UrlHelper"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _icons = require("@material-ui/icons");

var _dompurify = _interopRequireDefault(require("dompurify"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TRACK_KINDS = {
  CAPTIONS: 'captions',
  THUMBNAIL: 'thumbnail'
};
var DOM_PREFIX = 'videoPlaylistContainer_';

var DrupalVideoPlaylistNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalVideoPlaylistNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalVideoPlaylistNugget);

  function DrupalVideoPlaylistNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalVideoPlaylistNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "prepareVideoList", function () {
      var nugget = _this.getNugget();

      var videos = nugget.videos;
      videos.forEach( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(video, index) {
          var correctedVideoData;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.getCorrectVideoUrl(video.src);

                case 2:
                  correctedVideoData = _context.sent;
                  video.src = correctedVideoData.src;
                  video.subtitleUrl = correctedVideoData.subtitleUrl;
                  video.thumbnailUrl = correctedVideoData.thumbnailUrl;

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());

      _this.setState({
        preparedVideos: videos
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "removeListeners", function () {
      if (_this.videoRef && _this.videoRef.current && _this.listenersSet) {
        _this.videoRef.current.removeEventListener('play', _this.onPlay);

        _this.videoRef.current.removeEventListener('pause', _this.onPause);

        _this.videoRef.current.removeEventListener('stop', _this.onStop);

        _this.videoRef.current.removeEventListener('ended', _this.playNextTrack);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "addListeners", function () {
      if (_this.videoRef && _this.videoRef.current && !_this.listenersSet) {
        _this.videoRef.current.addEventListener('ended', _this.playNextTrack);

        _this.videoRef.current.addEventListener('play', _this.onPlay);

        _this.videoRef.current.addEventListener('stop', _this.onStop);

        _this.videoRef.current.addEventListener('pause', _this.onPause);

        _this.listenersSet = true;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPlay", function () {
      _this.setState({
        videoIsPlaying: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onStop", function () {
      _this.setState({
        videoIsPlaying: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPause", function () {
      _this.setState({
        videoIsPlaying: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getCorrectVideoUrl", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(videoM3u8) {
        var subtitleUrl, m3u8, parts, filename, mediaId, infoUrl, videoRequestResult, sources, tracks, thumbnailUrl, optimalLongSide, longSideDiff, optimalMp4File, width, i, l, description;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                subtitleUrl = null;
                m3u8 = _this._correctM3u8(_dompurify["default"].sanitize(videoM3u8, {
                  ALLOW_UNKNOWN_PROTOCOLS: true
                }));
                _context2.prev = 2;
                parts = _UrlHelper["default"].parseURL(m3u8);
                filename = parts.pathname.split('/').pop();
                mediaId = filename.substring(0, filename.indexOf('.'));
                infoUrl = parts.protocol + '//cdn.jwplayer.com/v2/media/' + mediaId;
                _context2.next = 9;
                return (0, _HttpRequest.httpGetExtern)(infoUrl, {}, null, null, null, null);

              case 9:
                videoRequestResult = _context2.sent;

                if (!(videoRequestResult.status === 200 && videoRequestResult.data)) {
                  _context2.next = 35;
                  break;
                }

                if (_this.errorTimeout) _this.errorTimeout.invalidate();
                sources = videoRequestResult.data.playlist[0].sources;
                tracks = videoRequestResult.data.playlist[0].tracks;
                thumbnailUrl = _this._correctUrl(videoRequestResult.data.playlist[0].image);
                tracks.forEach(function (track) {
                  if (track && track.kind && track.kind === TRACK_KINDS.CAPTIONS) {
                    subtitleUrl = _this._correctUrl(track.file);
                  }
                });
                optimalLongSide = null;
                longSideDiff = null;
                optimalMp4File = null; //        const width = Math.max(window.screen.height, window.screen.width) || 640

                width = Math.max(window.innerHeight, window.innerWidth) || 640; // const width = this.videoElement && this.videoElement.offsetWidth > 0 ? this.videoElement.offsetWidth : 640

                i = 0, l = sources.length;

              case 21:
                if (!(i < l)) {
                  _context2.next = 31;
                  break;
                }

                description = sources[i];

                if (!(description.label === 'Passthrough')) {
                  _context2.next = 25;
                  break;
                }

                return _context2.abrupt("continue", 28);

              case 25:
                if (description.hasOwnProperty('width')) {
                  _context2.next = 27;
                  break;
                }

                return _context2.abrupt("continue", 28);

              case 27:
                if (!optimalLongSide || Math.abs(width - description.width) < longSideDiff) {
                  optimalMp4File = description.file;
                  optimalLongSide = description.width;
                  longSideDiff = Math.abs(width - optimalLongSide);
                }

              case 28:
                i++;
                _context2.next = 21;
                break;

              case 31:
                if (!optimalMp4File) {
                  _context2.next = 33;
                  break;
                }

                return _context2.abrupt("return", {
                  src: optimalMp4File,
                  subtitleUrl: subtitleUrl,
                  thumbnailUrl: thumbnailUrl
                });

              case 33:
                _context2.next = 36;
                break;

              case 35:
                console.log('ERROR', 'DrupalVideoNugget.getCorrectVideoUrl', 'status != 200', videoRequestResult);

              case 36:
                _context2.next = 41;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t0 = _context2["catch"](2);
                console.log('ERROR', 'Drupal.VideoNugget.getCorrectVideoUrl', _context2.t0);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 38]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "playNextTrack", function () {
      var newIndex = _this.state.currentlyPlayingIndex + 1;

      if (_this.state.preparedVideos.length > newIndex) {
        var newName = _this.state.preparedVideos[newIndex].name;

        _this.playTrack(_this.state.currentlyPlayingIndex + 1, newName);
      } else {
        _this.setState({
          currentlyPlayingIndex: -1,
          currentlyPlayingTitle: null,
          videoIsPlaying: false
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "playTrack", function (index, title) {
      var videoPlayer = _this.videoRef.current;

      if (videoPlayer) {
        var trackUrl = _this.state.preparedVideos.length > index ? _this.state.preparedVideos[index].src : null;

        if (trackUrl) {
          if (_this.state.currentlyPlayingIndex !== index) {
            videoPlayer.setAttribute('src', trackUrl);

            _this.setState({
              currentlyPlayingTitle: title,
              currentlyPlayingIndex: index
            }, function () {
              videoPlayer.load();
              videoPlayer.play();
            });
          } else {
            videoPlayer.play();
          }
        } else {
          videoPlayer.stop();
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "pauseVideo", function () {
      var videoPlayer = _this.videoRef.current;

      if (videoPlayer) {
        videoPlayer.pause();

        _this.setState({
          videoIsPlaying: false
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "toogleTranscript", function () {
      var isOpen = _this.state.transcriptOpen;

      _this.setState({
        transcriptOpen: !isOpen
      });
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      waitingForDelete: false,
      checkedBoxes: [],
      mobilePageIndex: 0,
      currentlyPlayingTitle: null,
      currentlyPlayingIndex: 0,
      videoIsPlaying: false,
      transcriptOpen: false,
      preparedVideoList: []
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.videoRef = /*#__PURE__*/_react["default"].createRef();
    _this.listenersSet = false;
    _this.domId = _StringHelper["default"].createShortId();
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _VideoPlaylistNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalVideoPlaylistNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalVideoPlaylistNugget, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalVideoPlaylistNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "_correctUrl",
    value: function _correctUrl(url) {
      if (url.match('cdn.equeo.de')) {
        url = url.replace(/cdn.equeo.de/, 'assets-jpcust.jwpsrv.com');
      }

      return this._correctProtocol(url);
    }
  }, {
    key: "_correctProtocol",
    value: function _correctProtocol(url) {
      var protocol = window.location.protocol.toLowerCase();

      if (protocol === 'file:' || protocol === 'https:' || protocol === 'http:') {
        var parts = _UrlHelper["default"].parseURL(url);

        var protocolToUse = protocol === 'file:' ? 'https:' : protocol;
        var host = protocol === 'https:' && parts.host.match(/:80$/) ? parts.host.substring(0, parts.host.length - 3) : protocol === 'http:' && parts.host.match(/:443$/) ? parts.host.substring(0, parts.host.length - 4) : parts.host;
        return protocolToUse + '//' + host + (parts.pathname.substring(0, 1) !== '/' ? '/' : '') + parts.pathname + parts.search + parts.hash;
      }

      return url;
    }
  }, {
    key: "_correctM3u8",
    value: function _correctM3u8(url) {
      if (url.match('cdn.equeo.de')) {
        url = url.replace(/cdn.equeo.de/, 'content.jwplatform.com');
      }

      return this._correctProtocol(url);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.prepareVideoList();
      this.registerNuggetPosition(this.props.id, _VideoPlaylistNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      this.addListeners();
    }
    /**
     * @return {VideoPlaylistNugget}
     */

  }, {
    key: "getNugget",
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalVideoPlaylistNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      this.addListeners();
      var nugget = this.state.content[prevProps.id];

      if (this.state.preparedVideos && this.state.preparedVideos.length > 0 && !this.state.currentlyPlayingTitle) {
        this.setState({
          currentlyPlayingTitle: this.state.preparedVideos[0].name
        });
      }

      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {VideoPlaylistNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var backgroundColor = this.props.lectureBackgroundColor && _cssConstants["default"].colorMap ? _cssConstants["default"].colorMap[this.props.lectureBackgroundColor] : _cssConstants["default"].colors.buttonBackground;
      var currentIndex = this.state.currentlyPlayingIndex;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "videoPlaylistContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "videoPlaylistNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title && (_config["default"].targetTag !== "visitberlin" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : /*#__PURE__*/_react["default"].createElement("h1", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title)), nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'infoContainer ctnVideoPlaylistContent',
        style: {
          paddingBottom: '20px',
          position: 'relative'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'info',
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }), /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
        style: {
          color: backgroundColor
        },
        className: "videoPlaylistPlayButton ".concat(_DrupalVideoPlaylistNugget["default"].playButtonCentered),
        onClick: function onClick() {
          _this2.playTrack(0, null);
        }
      })) : null, this.state.preparedVideos && this.state.preparedVideos.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, this.state.currentlyPlayingTitle ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoPlaylistNugget["default"].playingTitle
      }, this.state.currentlyPlayingTitle) : null, /*#__PURE__*/_react["default"].createElement("video", {
        controls: true,
        ref: this.videoRef,
        controlsList: 'nodownload',
        id: this.domId,
        poster: this.state.preparedVideos[currentIndex].thumbnailUrl,
        className: _DrupalVideoPlaylistNugget["default"].bigVideoPlayer,
        preload: 'none',
        crossOrigin: 'anonymous',
        src: this.state.preparedVideos[currentIndex].src
      }, this.state.preparedVideos[currentIndex].subtitleUrl ? /*#__PURE__*/_react["default"].createElement("track", {
        label: "Untertitel",
        kind: "subtitles",
        srcLang: "de",
        src: this.state.preparedVideos[currentIndex].subtitleUrl
      }) : null), this.state.preparedVideos[currentIndex].transcript ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoPlaylistNugget["default"].transcriptContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoPlaylistNugget["default"].transcriptTitle,
        onClick: function onClick() {
          return _this2.toogleTranscript();
        }
      }, "Transkript zum Video ", this.state.transcriptOpen ? /*#__PURE__*/_react["default"].createElement(_icons.ArrowDropDown, {
        className: _DrupalVideoPlaylistNugget["default"].transcriptArrow
      }) : /*#__PURE__*/_react["default"].createElement(_icons.ArrowRight, {
        className: _DrupalVideoPlaylistNugget["default"].transcriptArrow
      })), this.state.transcriptOpen ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoPlaylistNugget["default"].transcriptText,
        dangerouslySetInnerHTML: {
          __html: this.state.preparedVideos[currentIndex].transcript
        }
      }) : null) : null, this.state.preparedVideos.map(function (video, index) {
        if (!video.active || !video.src) return null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoPlaylistNugget["default"].videoItem,
          key: video.name
        }, _this2.state.currentlyPlayingIndex === index && _this2.state.videoIsPlaying ? /*#__PURE__*/_react["default"].createElement(_PauseCircleFilled["default"], {
          className: "videoPlayButton ".concat(_DrupalVideoPlaylistNugget["default"].playButton),
          onClick: function onClick() {
            _this2.pauseVideo();
          }
        }) : /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
          className: "videoPlayButton ".concat(_DrupalVideoPlaylistNugget["default"].playButton),
          onClick: function onClick() {
            _this2.playTrack(index, video.name);
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoPlaylistNugget["default"].infoContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoPlaylistNugget["default"].videoFileName
        }, video.name), video && video.info ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoPlaylistNugget["default"].videoFileInfo
        }, video.info) : null));
      }))), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalVideoPlaylistNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalVideoPlaylistNugget;
DrupalVideoPlaylistNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  registerSendFunc: _propTypes["default"].func,
  lectureBackgroundColor: _propTypes["default"].string,
  setLike: _propTypes["default"].func
};
DrupalVideoPlaylistNugget.defaultProps = {
  id: null
};